import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Form, Field } from 'react-final-form';
import { Link } from "react-router-dom";
import { Row, Col, ButtonGroup, Button, Card, CardHeader, CardBody, CardTitle, CardText, CardFooter } from 'reactstrap';
import { FormGroup, Label } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { loadCourse, startRollcall } from '../../../redux/modules';
import { Course, Payment, User } from '../../../models/';
import { Utils, isSuperAdmin, hasModule } from '../../../services/';
import {
    AttendanceField, CourseListItem,
} from '../../../components';
import Icon from '@mdi/react';
import {
    mdiLoading,
    mdiRoomServiceOutline,
    mdiAccountArrowRightOutline,
    mdiAccountSchoolOutline,
    mdiAccountChildOutline,
    mdiCardAccountPhoneOutline,
    mdiAccountGroupOutline,
    mdiAccountMultiplePlus,
    mdiCommentAccountOutline,
    mdiAccountCreditCardOutline,
    mdiTrashCanOutline,
} from '@mdi/js';
import _ from 'lodash';


import './CourseForm.css';

const CourseForm = ({ onSubmit, isCreation }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const { users }              = useSelector(state => state.users);
    const { groups }             = useSelector(state => state.groups);
    const { course, courses, isLoading, isLoadingOne } = useSelector(state => state.courses);

    const reloadCourse = () => {
        dispatch(loadCourse(course.id));
    };

    const _startRollcall = () => {
        dispatch(startRollcall(course));
    }

    return (
        <Form
            initialValues={ course }
            onSubmit={ values => { onSubmit(values); }}
            render={({ handleSubmit, pristine, form, submitting }) => (
                <form className="form" onSubmit={handleSubmit}>
                    <CourseListItem course={ course } className="mb-3" />
                    <Field component="input" type="hidden" name="user_id" />
                    <Row className="main row-flex">
                        <Col sm={12} lg={12}>
                            <Card color="light" className="h-100">
                                <CardBody>
                                    <CardTitle tag="h3">
                                        <Icon path={mdiCommentAccountOutline} size={1.5} />&nbsp;
                                        {t('courses.other_informations')}
                                    </CardTitle>
                                    <CardText tag="div">
                                        <FormGroup row>
                                            <Col sm={12}>
                                                <Field component="textarea" rows={ 6 } className="form-control" name="remarks" id="remarks" />
                                            </Col>
                                        </FormGroup>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="main row-flex">
                        <Col sm={12} lg={12}>
                            <Card color="light" className="h-100">
                                <CardHeader>
                                    <CardTitle tag="h3">
                                        <Icon path={mdiAccountSchoolOutline} size={1.5} />&nbsp;
                                        {t('courses.students_presence')}
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <CardText tag="div">
                                        {course?.attendances?.length === 0 && (
                                            <div className="text-center">
                                                <Button onClick={_startRollcall} color="info">
                                                    <Icon path={mdiRoomServiceOutline} size={1} />&nbsp;
                                                    {t('courses.start_rollcall')}
                                                </Button>
                                            </div>
                                        )}
                                        <Row className="row-cols-1 row-cols-xl-2">
                                            {_.sortBy((course?.attendances || []), ['student.lastname, student.firstname']).map((attendance, i) => (
                                            <Col key={i}>
                                                <Card className="mb-1">
                                                    <CardBody>
                                                        <Row>
                                                            <Col>
                                                                <h3>{attendance.student.lastname}</h3>&nbsp;
                                                                {attendance.student.firstname}
                                                            </Col>
                                                            <Col>
                                                                <AttendanceField name={`attendances[${i}].attendance`} defaultValue={attendance.attendance} onValueChange={v => console.log(v)}/>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field name={`attendances[${i}].explanation`} component="input" type="text" className="form-control" placeholder={t('courses.explanation')}/>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        ))}
                                        </Row>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="main">
                        <Col className="text-center">
                            <ButtonGroup>
                                <Button tag={Link} to={ -1 } color="warning">
                                    <span><i className="fa fa-arrow-left"></i>&nbsp;{t('common.back')}</span>
                                </Button>
                                <Button type="submit" color="success" disabled={pristine || submitting || isLoading}>
                                    <span>
                                        <i className={`fa ${ isLoading ? 'fa-spinner fa-spin' : 'fa fa-save'}`}></i>&nbsp;{t("common.save")}
                                    </span>
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                </form>
        )} />
    );
}

export default CourseForm;
